import { Box } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useStore } from "../../../api/main/appStore";
import PendingWithdrawalsTable from "../tables/PendingWithdrawalsTable";

export default observer(function PendingWithdrawals() {
  const { paymentStore } = useStore();

  useEffect(() => {
    (async () => {
      await paymentStore.getWithdrawalRequests({
        status: "N",
        pageNumber: 1,
        pageSize: 50,
      });
    })();
  }, []);

  return (
    <Box>
      <PendingWithdrawalsTable data={paymentStore.pendingWithdrawalRequests} />
    </Box>
  );
});
